import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { useQueryClient } from 'react-query'
import { useHistory } from 'react-router-dom'
import CustomAddPage from '../../components/CustomComponents/CustomAddPage'
import { createDocument, updateDocumentByID } from '../../lib/RestApi/customApiHandler'
import { useFeatures } from '../../hooks/Features/useFeatures'

export default function AddTravelCategory({ travelCategory: travelCategoryData }) {
  const queryClient = useQueryClient()
  const history = useHistory()
  const [travelCategory, setTravelCategory] = useState({
    name: travelCategoryData ? travelCategoryData.name : '',
    allowanceType: travelCategoryData ? travelCategoryData.allowanceType : '',
  })
  const { getAllowanceTypes, allowanceTypes} = useFeatures()

  const data = [
    { label: 'Travel Category Name', value: travelCategory.name, name: 'name',  },
    {label: 'Allowance Type', value: travelCategory.allowanceType, name: 'allowanceType', options: allowanceTypes,fieldName: 'name', fieldValue: '_id'},
  ]

  const [loading, setLoading] = useState(false)

  
  const handleClick = async () => {
    setLoading(true)

    if (travelCategoryData) {
      await updateDocumentByID('/travel/category', travelCategoryData._id, {...travelCategory, _id: travelCategoryData._id})
      queryClient.invalidateQueries('business-category')
      setLoading(false)
    } else {
      await createDocument('/travel/category', travelCategory)
      queryClient.invalidateQueries('travel-category')
      setLoading(false)
    }

    history.push('/travel-category')
  }

  useEffect(()=>{
      getAllowanceTypes();
  }, [])

  return (
    <CustomAddPage
      heading="Travel Category"
      redirect={'TRAVEL_CATEGORY'}
      currentData={travelCategory}
      loading={loading}
      state={travelCategory}
      setState={setTravelCategory}
      handleClick={handleClick}
      inputFields={data}
    />
  )
}
